import React from 'react';
import { Textarea } from '../../../../components/ui/textarea';
import { AiButton, Field, StreamPreview, inputCls, wordCount } from '../shared';

const StepOriginal = ({ wf, setData, runAi, ai }) => {
  const d = wf.data?.original || {};
  const running = ai.running && ai.action === 'original_apply';

  const apply = async () => {
    const res = await runAi('original_apply', { info: d.info || '' });
    if (res) setData('original', { applied_at: new Date().toISOString() });
  };

  return (
    <div className="space-y-6">
      <Field label="Original BriefingIQ information" hint="Proprietary data points, anonymised customer stories, executive quotes, screenshots to reference. Only include what is approved for publication." testId="original-info-field">
        <Textarea value={d.info || ''} onChange={(e) => setData('original', { info: e.target.value })} rows={10} className={inputCls} placeholder={'e.g. Across BriefingIQ customers in 2025, briefed opportunities closed a median 29 days faster…\nQuote: "…" — VP Strategic Programs, Fortune 500 software company'} data-testid="original-info-input" />
      </Field>
      <div className="flex items-center gap-3 flex-wrap">
        <AiButton onClick={apply} running={running} label="Integrate into draft with AI" runningLabel="Integrating…" testId="original-apply-btn" disabled={!d.info?.trim()} />
        <span className="text-xs text-ink-3">Draft: {wordCount(wf.article?.content)} words{d.applied_at ? ' · original info integrated' : ''}</span>
      </div>
      {running && <StreamPreview text={ai.text} label="Integrating original information…" />}
      <div className="text-xs text-ink-3">This step is optional. Original data is what search engines and readers reward most — even one proprietary number helps.</div>
    </div>
  );
};

export default StepOriginal;
